import type { Maybe } from '@adornis/base/utilTypes.js';
import { constructValue } from '@adornis/baseql/entities/construct.js';
import { registerQuery } from '@adornis/baseql/metadata/register.js';
import { getCollection } from '@adornis/baseql/server/collections.js';
import { Publishment } from '../db/Publishment.js';

export const deletePublishmentByEntity = registerQuery({
  type: () => String,
  operationName: 'deletePublishmentByEntity',
  resolve: (entityID: string) => {
    return async () => {
      const collection = await getCollection<Publishment>(Publishment._class);
      const result = constructValue<Maybe<Publishment>>(await collection.findOne<Publishment>({ entityID }));
      if (!result) throw new Error(`no publishment with entityID '${entityID}' found.`);
      await result.remove();
    };
  },
  params: [{ name: 'entityID', type: () => String }],
});
